/**
 * https://responsive.pics/
 * https://github.com/aFarkas/lazysizes
 * https://github.com/scottjehl/picturefill (polyfill)
 */

import 'lazysizes';
import 'lazysizes/plugins/aspectratio/ls.aspectratio.js';
import 'picturefill';

function init() {
  // TODO: iframe markup adjustments
  // <iframe data-src="embed.html" class="lozad"></iframe>
  // const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  // observer.observe();
}

export default init;



// WEBPACK FOOTER //
// ./scripts/base/responsivePics.js